import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { noteProjection } from "../sanity/note.projection"

export const queryNote = {
  async note(parent, args, context, info) {
    const { lang = AppSettings.defaultLocale(), cdn = true, id } = args
    const { user } = context

    if (!id) return null

    await checkPermissions({
      user,
      domainObject: DomainObjects.NOTES,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const draftsFilter = `&& !(_id in path("drafts.**")) && status != "X"`

    const note = await client.fetch(
      groq`*[_type=="note" && _id==$id ${draftsFilter}][0] {
        ${noteProjection()}
      }`,
      { id: id },
    )

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: note.customerNumber,
    })

    return note ?? null
  },
}
